var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 .2C5.072.2.248 5.024.2 10.928a10.642 10.642 0 003.12 7.656c2.016 2.064 4.728 3.192 7.608 3.216H11c5.928 0 10.752-4.824 10.8-10.728C21.848 5.12 17.024.248 11 .2zm5.232 14.4l-.456.456-.024.024c-.792.792-1.464.984-2.52.672-1.104-.336-2.088-.936-2.976-1.656-1.272-1.032-2.64-2.376-3.528-3.768-.888-1.44-1.176-2.952.072-4.2l.024-.024.456-.456c.336-.336.888-.336 1.248 0l1.416 1.416c.336.336.336.888 0 1.248l-.84.84.024.024a12.686 12.686 0 003.576 3.576l.024.024.84-.84c.336-.336.888-.336 1.248 0l1.416 1.416c.36.36.36.912 0 1.248z",
    fill: "#9C7D3E"
  })));
}
export default SvgPhoneinline;